// extracted by mini-css-extract-plugin
module.exports = {"buttons":"QuestionPage_buttons__1jTkC"};